import FetchFactory, {
	DeleteRequest,
	GetRequest,
	ModifyRequest
} from "utils/fetch/FetchRequest";

import { CreateResourceInfo, ResourceInfo, UserAccess } from "./ResourceTypes";

const ENDPOINT = "/api/resources";
const RIGHTS_SUFFIX = "rights";
const CONTENT_SUFFIX = "content";

export default class ResourceClient {
	public static getAll(): GetRequest<Array<ResourceInfo>> {
		return FetchFactory.get(ENDPOINT);
	}

	public static create(
		data: CreateResourceInfo
	): ModifyRequest<CreateResourceInfo, string> {
		return {
			operation: "POST",
			url: ENDPOINT,
			body: data,
			statusCode: 201,
			callback: response => {
				const location = response.headers.get("location");
				if (location === null) {
					return Promise.reject(
						new Error("Missing location header!")
					);
				} else {
					return Promise.resolve(location);
				}
			}
		};
	}

	public static getInfo(id: number): GetRequest<ResourceInfo> {
		return FetchFactory.get(`${ENDPOINT}/${id}`);
	}

	public static getRights(id: number): GetRequest<Array<UserAccess>> {
		return FetchFactory.get(`${ENDPOINT}/${id}/${RIGHTS_SUFFIX}`);
	}

	public static getContent(id: number): GetRequest<Blob> {
		return {
			operation: "GET",
			url: `${ENDPOINT}/${id}/${CONTENT_SUFFIX}`,
			statusCode: 200,
			callback: response => response.blob()
		};
	}

	public static updateContent(
		id: number,
		data: FormData
	): ModifyRequest<FormData, void> {
		return {
			operation: "PUT",
			url: `${ENDPOINT}/${id}/${CONTENT_SUFFIX}`,
			body: data,
			statusCode: 200,
			callback: () => Promise.resolve()
		};
	}

	public static delete(id: number): DeleteRequest<void> {
		return FetchFactory.del(`${ENDPOINT}/${id}`);
	}
}
